<div class="new-transfer-modal-container p-4 bg-white rounded-4 position-relative">

  <!-- Header -->
  <div class="d-flex align-items-start justify-content-between mb-3">
    <div class="d-flex align-items-center gap-3">
      <div class="modal-title-icon-box rounded-circle d-flex align-items-center justify-content-center">
        <fa-icon [icon]="faExchangeAlt" class="title-icon"></fa-icon>
      </div>
      <div>
        <h4 class="modal-heading-title m-0 fw-bold">New Balance Transfer</h4>
        <span class="modal-heading-subtitle text-muted small">Move funds between balance accounts.</span>
      </div>
    </div>
    <button type="button" class="btn-close shadow-none ms-2" aria-label="Close"
      [disabled]="saveLoader" (click)="activeModal.dismiss()"></button>
  </div>

  <!-- Info Alert Box -->
  <div class="info-alert-box p-3 rounded-3 mb-3 d-flex align-items-start gap-2">
    <fa-icon [icon]="faInfoCircle" class="info-icon mt-1"></fa-icon>
    <span class="info-alert-text">
      We show available balance for reference. Balance transfers can exceed it — accounts may go negative.
    </span>
  </div>

  <!-- Error Alert -->
  @if (errorMessage) {
    <div class="alert alert-danger py-2 mb-3 small d-flex justify-content-between align-items-center rounded-3">
      <span>{{ errorMessage }}</span>
      <button type="button" class="btn-close small py-1 shadow-none" style="font-size: 0.75rem;"
        (click)="errorMessage = ''"></button>
    </div>
  }

  <!-- Transfer Form -->
  <form [formGroup]="transferForm" (ngSubmit)="saveTransfer()" class="d-flex flex-column gap-3">

    <!-- Source Balance Account -->
    <div>
      <label for="sourceAccountSelect" class="form-label modal-form-label mb-1">Source balance account *</label>
      <ng-select labelForId="sourceAccountSelect" [items]="balanceAccounts" bindLabel="accountName" bindValue="_id"
        formControlName="sourceAccountId" [clearable]="false" [searchable]="!defaultSourceAccountId" [disabled]="!!defaultSourceAccountId"
        placeholder="Select source account" [loading]="accountsLoader" class="custom-ng-select">
        <ng-template ng-option-tmp let-item="item">
          <div class="py-1 w-100">
            <span class="fw-semibold text-dark" style="font-size: 13px;">{{ item.accountName }}</span>
          </div>
        </ng-template>
      </ng-select>
      @if (transferForm.get('sourceAccountId')?.touched && transferForm.get('sourceAccountId')?.invalid) {
        <div class="text-danger small mt-1">
          Source balance account is required
        </div>
      }
    </div>

    <!-- Destination Balance Account -->
    <div>
      <label for="destAccountSelect" class="form-label modal-form-label mb-1">Destination balance account *</label>
      <ng-select labelForId="destAccountSelect" [items]="destinationBalanceAccounts" bindLabel="accountName" bindValue="_id"
        formControlName="destinationAccountId" [clearable]="false" [searchable]="true" placeholder="Select destination account"
        [loading]="accountsLoader" class="custom-ng-select">
        <ng-template ng-option-tmp let-item="item">
          <div class="py-1 w-100">
            <span class="fw-semibold text-dark" style="font-size: 13px;">{{ item.accountName }}</span>
          </div>
        </ng-template>
      </ng-select>
      @if (transferForm.get('destinationAccountId')?.touched && transferForm.get('destinationAccountId')?.invalid) {
        <div class="text-danger small mt-1">
          Destination balance account is required
        </div>
      }
    </div>

    <!-- Amount -->
    <div>
      <label for="transferAmount" class="form-label modal-form-label mb-1">Amount *</label>
      <input id="transferAmount" type="number" class="form-control modal-input" formControlName="amount"
        placeholder="e.g. ₹25,000" (wheel)="onNumberWheel($event)" (keydown)="onNumberKeyDown($event)" />
      @if (transferForm.get('amount')?.touched && transferForm.get('amount')?.invalid) {
        <div class="text-danger small mt-1">
          @if (transferForm.get('amount')?.errors?.['required']) {
            Amount is required
          }
          @if (transferForm.get('amount')?.errors?.['invalidAmount']) {
            Amount must be greater than 0
          }
        </div>
      }
    </div>

    <!-- Balance Transfer Date -->
    <div #dateContainer class="position-relative">
      <label class="form-label modal-form-label mb-1 d-block">Balance transfer date *</label>
      <div class="modal-input d-flex align-items-center justify-content-between cursor-pointer bg-white"
        [ngClass]="{'form-disabled': saveLoader}" (click)="!saveLoader && dp.toggle()">
        <span class="fw-medium text-dark">{{ transferDateFormatted }}</span>
        <fa-icon [icon]="faChevronDown" class="text-muted small"></fa-icon>
      </div>
      @if (transferForm.get('transferDate')?.touched && transferForm.get('transferDate')?.invalid) {
        <div class="text-danger small mt-1">
          Balance transfer date is required
        </div>
      }
      <input class="datepicker-hidden-input" name="dp" ngbDatepicker #dp="ngbDatepicker"
        [positionTarget]="dateContainer" [maxDate]="maxDate" [startDate]="selectedNgbDate"
        [(ngModel)]="selectedNgbDate" [ngModelOptions]="{standalone: true}" (dateSelect)="onDateSelect($event)" />
    </div>

    <!-- Note (Optional) -->
    <div>
      <label for="transferNotes" class="form-label modal-form-label mb-1">Note</label>
      <input id="transferNotes" type="text" class="form-control modal-input" formControlName="notes"
        placeholder="Optional reference for this balance transfer" />
    </div>

    <!-- Action Buttons -->
    <div class="d-flex flex-column gap-2 mt-2">
      <button type="submit" class="btn submit-transfer-btn w-100 py-2.5 d-flex justify-content-center align-items-center gap-2"
        [disabled]="transferForm.invalid || saveLoader">
        @if (saveLoader) {
          <fa-icon [icon]="faSpinner" [animation]="'spin'" class="me-1"></fa-icon>
        } @else {
          <span>New Balance Transfer</span>
          <fa-icon [icon]="faCheck" class="small"></fa-icon>
        }
      </button>

      <button type="button" class="btn cancel-transfer-btn w-100 py-2.5"
        [disabled]="saveLoader" (click)="activeModal.dismiss()">
        Cancel
      </button>
    </div>

  </form>

</div>
